@import 'styles/mixins';
@import 'styles/variables';

.wrapper {
  width: 24px;
  height: 24px;
  background: var(--light-100);
  border-radius: 50%;
  position: relative;
  overflow: hidden;

  .circle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: var(--dark-8);
  }
}
